import reactComponentLoader from 'scripts/react-component-loader'

import { Payment } from 'checkout/pages/Payment'
import { UserInvalid } from 'checkout/components/Disclaimers'
import { CouponAvailable } from 'checkout/components/CouponAvailable'
import { BankSlipInstallments } from 'checkout/components/BankSlipInstallments'

reactComponentLoader(Payment, '[data-checkout-payment]')
reactComponentLoader(UserInvalid, '[data-checkout-disclaimer-user-invalid]')
reactComponentLoader(CouponAvailable, '[data-checkout-coupon-available]')
reactComponentLoader(BankSlipInstallments, '[data-checkout-bank-slip-installments]')
